import { ApplicationElement, html } from '../application_element/element.js';
import CopyBox from '../copy_box/element.js';
import style from './style.lit.css';

/**
 * Allows copy on click, copies strValue prop
 *
 * @cssprop [--value-max-height: 110px] Max height of textarea showing the value. Content will be scrollable if its height exceeds this value.
 *
 * @slot default - For the custom copy button
 */

export default class CopyBoxBlock extends CopyBox {
  static styles = [ApplicationElement.styles, style];

  render() {
    return html`
      <div aria-label="Copy content">${this.strValue}</div>
      <slot @click=${this.handleClick}></slot>
    `;
  }
}

CopyBoxBlock.registerTagName('ef-copy-box-block');

customElements.get('ef-copy-box-block') ||
  customElements.define('ef-copy-box-block', CopyBoxBlock);
